// extracted by mini-css-extract-plugin
export var information = "FormInformation-module--information--81abd";